import { render, staticRenderFns } from "./SnapshotService.vue?vue&type=template&id=f710aac4&lang=pug"
import script from "./SnapshotService.vue?vue&type=script&lang=ts"
export * from "./SnapshotService.vue?vue&type=script&lang=ts"
import style0 from "./SnapshotService.vue?vue&type=style&index=0&id=f710aac4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports